/**
 * UI 관련 전역 store
 * - 현재 페이지 index (~2depth)
 * - PC/MO 등 디바이스 정보
 * - window 너비 기반 breakpoint 정보
 * - 현재 네트워크망 정보
 */

import { createWithEqualityFn } from "zustand/traditional";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { enableMapSet } from "immer";
import { getBp, getNetwork, getDeviceType } from "@core/utils/uiUtil";
import type { IUiStore, bpType, deviceType, networkType, dialogDataType } from "@core/types/uiType";

enableMapSet(); // immer - Map 쓰기 위해 필요 (한 번만 호출하면 됨)

const apiNetwork = window?.__API_NETWORK__;

// shallow 등 equalityFn 사용하기 위해선 createWithEqualityFn 사용하여 store 생성 필요
export const useUiStore = createWithEqualityFn<IUiStore>()(
  devtools(
    immer((set, get) => ({
      device: getDeviceType(),
      bp: getBp(window.innerWidth),
      network: ["local", "sb"].includes(apiNetwork ?? "") ? apiNetwork : getNetwork(),
      isCnbOpen: false, // cnb 열림 상태, 페이지 전환 시 cnb 열려있으면 닫기 위해 전역 state로 올림
      openDialogList: new Map(),
      queryClient: null, // index.tsx 에서 생성한 queryClient 저장
      isPcView: () => get().bp === "lg",
      isMobileView: () => get().bp !== "lg",
      setDevice: (device: deviceType) => set({ device }),
      setBp: (bp: bpType) => set({ bp }),
      setNetwork: (network: networkType) => set({ network }),
      setIsCnbOpen: (isCnbOpen: boolean) => set({ isCnbOpen }),
      openDialog: (dialog: dialogDataType) =>
        set((state) => {
          state.openDialogList.set(JSON.stringify(dialog), dialog);
        }),
      closeDialog: (dialog: dialogDataType) =>
        set((state) => {
          state.openDialogList.delete(JSON.stringify(dialog));
        }),
    })),
    {
      name: "ncfz-uiStore",
      enabled: process.env.NODE_ENV === "development", // 개발 환경에서만 활성화
    },
  ),
);
